import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { switchMap } from 'rxjs/operators';

import { 
  Client, 
  ClientRequest, 
  ClientUpdateStatusRequest, 
  ClientUpdateLogoRequest,
  } from '../models/client.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private apiUrl = `${environment.apiURL}`;

  constructor(private http: HttpClient) { }

  get baseApiUrl(): string {
    return this.apiUrl;
  }

  // Get all clients
  getClients(): Observable<Client[]> {
    return this.http.get<Client[]>(`${this.apiUrl}/client/list`);
  }

  // Get client by ID
  getClientById(clientId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/client/get/${clientId}`);
  }

    // Create new client
  createClient(clientRequest: ClientRequest): Observable<string> {
    return this.http.post<string>(`${this.apiUrl}/client/add`, clientRequest);
  }

  // Update existing client
  updateClient(clientId: string, clientRequest: ClientRequest): Observable<string> {
    return this.http.put<string>(`${this.apiUrl}/client/edit/${clientId}`, clientRequest);
  }

  // Check if client is associated with customers
  checkAssociatedWithCustomers(clientId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/client/checkAssociatedwithCustomers/${clientId}`);
  }

  // Delete client
  deleteClient(clientId: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/client/delete/${clientId}`);
  }

  // Update client status (Active/Inactive)
  updateClientStatus(clientId: string, statusRequest: ClientUpdateStatusRequest): Observable<string> {
    return this.http.patch<string>(`${this.apiUrl}/client/status/${clientId}`, statusRequest);
  }

  // Update client logo
  updateClientLogo(clientId: string, statusRequest: ClientUpdateLogoRequest): Observable<string> {
    return this.http.patch<string>(`${this.apiUrl}/client/logo/${clientId}`, statusRequest);
  }

  getImageAsBase64(url: string): Observable<string> {
    return this.http.get(url, { headers: new HttpHeaders({ 'X-Skip-Auth': 'true' }), responseType: 'blob' }).pipe(
      switchMap(blob => this.convertBlobToBase64(blob))
    );
  }

  private convertBlobToBase64(blob: Blob): Observable<string> {
    return new Observable(observer => {
      const reader = new FileReader();
      reader.onloadend = () => {
        observer.next(reader.result as string);
        observer.complete();
      };
      reader.readAsDataURL(blob);
    });
  }

  // Create new tag
  createTag(tagName: string): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/tags`, {
      tagName
    });
  }

  getClientslist(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/client/clients`);
  }

}